"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiKey2ExchangeApiKey = exports.initLib = exports.isSameKey = exports.BalanceProvider = exports.BalanceRunningStatus = exports.FutureTransferDirection = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const AssetAPILib_1 = require("../AssetAPI/AssetAPILib");
const BalanceHelper_1 = require("../helper/BalanceHelper");
const Transform_1 = require("../helper/Transform");
const AssetModels_1 = require("../Models/AssetModels");
var FutureTransferDirection;
(function (FutureTransferDirection) {
    FutureTransferDirection["SPOT_TO_FUTURE"] = "SPOT_TO_FUTURE";
    FutureTransferDirection["FUTURE_TO_SPOT"] = "FUTURE_TO_SPOT";
})(FutureTransferDirection || (exports.FutureTransferDirection = FutureTransferDirection = {}));
var BalanceRunningStatus;
(function (BalanceRunningStatus) {
    BalanceRunningStatus[BalanceRunningStatus["running"] = 0] = "running";
    BalanceRunningStatus[BalanceRunningStatus["stopped"] = 1] = "stopped";
})(BalanceRunningStatus || (exports.BalanceRunningStatus = BalanceRunningStatus = {}));
const BALANCE_CACHE_TAG = "key_balance_original_cache";
class BalanceProvider {
    constructor() {
        this.assetLib = new AssetAPILib_1.AssetAPILib();
        this.refreshSubject = new rxjs_1.Subject();
        this.subject = new rxjs_1.BehaviorSubject(undefined);
        this.tradeSubject = new rxjs_1.BehaviorSubject(undefined);
        this.tradeRunningStatus = BalanceRunningStatus.stopped;
        this.runningStatus = BalanceRunningStatus.stopped;
    }
    getCacheKey(apiKey, balanceType) {
        return `${apiKey.cloudKeyId || apiKey.key}_balance${balanceType ? `_${balanceType}` : ""}`;
    }
    getBalanceAcquireObservableV2$(apiKey, repeat = true, balanceType) {
        const identify = this.getCacheKey(apiKey, balanceType);
        return BalanceProvider.retrieveApi(apiKey)
            .pipe((0, operators_1.flatMap)((api) => {
            if (repeat) {
                return (0, rxjs_1.interval)(5000)
                    .pipe((0, operators_1.startWith)(0))
                    .pipe((0, operators_1.exhaustMap)(() => {
                    return (0, trade_utils_lib_1.requestWithRetry)(() => this.assetLib.fetchFullBalanceForTradeV2$(apiKey, balanceType), {
                        name: "fetch_full_balance",
                    });
                }));
            }
            else {
                return (0, trade_utils_lib_1.requestWithRetry)(() => this.assetLib.fetchFullBalanceForTradeV2$(apiKey, balanceType), {
                    name: "acquire_full_balance",
                });
            }
        }))
            .pipe((0, operators_1.tap)((data) => {
            if (!balanceType) {
                BalanceProvider.cachedBalanceMap.set(identify, data);
            }
        }));
    }
    static setRetrieveApiInterface(retrieveAPIFunc) {
        BalanceProvider.retrieveApi = retrieveAPIFunc;
    }
    stop() {
        ///> TODO something you want uninitialized
    }
    /**
     * 外部通知刷新balance主动更新一次（操作基金部分时由于websocket不推送，所以只能外来触发刷新一次）
     */
    notifyRefreshBalance() {
        this.refreshSubject.next("refresh");
    }
    wrapAcquireBalance(apiKey, repeat = true, balanceType) {
        let requireBalanceObservable;
        requireBalanceObservable = this.getBalanceAcquireObservableV2$(apiKey, repeat, balanceType);
        return requireBalanceObservable;
    }
    startIfNeed(apiKey, balanceType) {
        let isSameK = false;
        let isRunning = false;
        let listener = undefined;
        switch (balanceType) {
            case AssetModels_1.BALANCE_TYPE_V2.TRADE:
                isRunning = this.tradeRunningStatus === BalanceRunningStatus.running;
                isSameK = isSameKey(this.tradeCurrentKey, apiKey);
                if (!isSameK || !isRunning || !this.listenTradeBalance) {
                    this.tradeCurrentKey = apiKey;
                    this.tradeRunningStatus = BalanceRunningStatus.running;
                    this.listenTradeBalance = this.getBalanceWithApiKey(apiKey, true, balanceType)
                        .pipe((0, operators_1.multicast)(this.tradeSubject))
                        .pipe((0, operators_1.refCount)());
                }
                listener = this.listenTradeBalance;
                break;
            default:
                isRunning = this.runningStatus === BalanceRunningStatus.running;
                isSameK = isSameKey(this.currentKey, apiKey);
                if (!isSameK || !isRunning || !this.listenBalance) {
                    this.currentKey = apiKey;
                    this.runningStatus = BalanceRunningStatus.running;
                    this.listenBalance = this.getBalanceWithApiKey(apiKey, true, balanceType)
                        .pipe((0, operators_1.multicast)(this.subject))
                        .pipe((0, operators_1.refCount)());
                }
                listener = this.listenBalance;
                break;
        }
        return listener.pipe((0, operators_1.filter)((result) => {
            return result !== undefined;
        }));
    }
    getBalanceObservable(apiKey, balanceType) {
        return this.startIfNeed(apiKey, balanceType).pipe((0, operators_1.map)((balanceInfo) => {
            let balanceList = [];
            if (balanceType === AssetModels_1.BALANCE_TYPE_V2.TRADE) {
                const tradeBalanceList = (0, Transform_1.transformTradeBalance)(balanceInfo.trade, balanceInfo.debt || []).trade;
                if (tradeBalanceList.length > 0) {
                    balanceList.push(...tradeBalanceList);
                }
            }
            else if (balanceType === AssetModels_1.BALANCE_TYPE_V2.TRADER_ACCOUNT) {
                // balanceList = balanceInfo.traderAccount;
                throw { code: "-1", message: "getBalanceObservable not support trader account" };
            }
            else {
                const debtBalanceList = (0, Transform_1.transformTradeBalance)(balanceInfo.trade, balanceInfo.debt || []).debt;
                if (debtBalanceList.length > 0) {
                    balanceList.push(...debtBalanceList);
                }
            }
            ///> TODO check price field
            balanceList.forEach((item) => {
                if (item.usdPrice === undefined) {
                    item.usdPrice = 0;
                    item.usdChangePercent = 0;
                }
                if (item.btcPrice === undefined) {
                    item.btcPrice = 0;
                    item.btcChangePercent = 0;
                }
            });
            return balanceList;
        }));
    }
    // 外部调用此方法
    getAllBalanceObservable(apiKey) {
        return this.startIfNeed(apiKey).pipe((0, operators_1.map)((balanceInfo) => {
            var _a, _b, _c;
            let balanceList = [];
            const defaultTotalInfo = {
                financeTotalInBTC: 0,
                financeTotalInUSD: 0,
                totalInBTC: 0,
                totalInUSD: 0,
                tradeTotalInBTC: 0,
                tradeTotalInUSD: 0,
                manualTotalInBTC: 0,
                manualTotalInUSD: 0,
            };
            if (balanceInfo.trade.length > 0) {
                const mixResult = (0, Transform_1.transformTradeBalance)(balanceInfo.trade, balanceInfo.debt);
                balanceList.push(...mixResult.trade);
                balanceList.push(...mixResult.debt);
            }
            if (balanceInfo.arbitrageStrategy.length) {
                balanceList.push(...balanceInfo.arbitrageStrategy);
            }
            if (balanceInfo.swap.length) {
                balanceList.push(...balanceInfo.swap);
            }
            if (balanceInfo.cmSwap.length) {
                balanceList.push(...balanceInfo.cmSwap);
            }
            if (balanceInfo.deposit.length) {
                balanceList.push(...balanceInfo.deposit);
            }
            if (balanceInfo.dual.length) {
                balanceList.push(...balanceInfo.dual);
            }
            if ((_a = balanceInfo.dualAuto) === null || _a === void 0 ? void 0 : _a.length) {
                balanceList.push(...balanceInfo.dualAuto);
            }
            if ((_b = balanceInfo.moduleFinance) === null || _b === void 0 ? void 0 : _b.length) {
                balanceList.push(...balanceInfo.moduleFinance);
            }
            ///> TODO check price field
            balanceList.forEach((item) => {
                if (item.usdPrice === undefined) {
                    item.usdPrice = 0;
                    item.usdChangePercent = 0;
                }
                if (item.btcPrice === undefined) {
                    item.btcPrice = 0;
                    item.btcChangePercent = 0;
                }
            });
            return {
                total: (_c = balanceInfo === null || balanceInfo === void 0 ? void 0 : balanceInfo.total) !== null && _c !== void 0 ? _c : defaultTotalInfo,
                exchangeBalances: balanceList,
                traderBalances: balanceInfo.traderAccount,
            };
        }));
    }
    getTradeBalanceObservable(apiKey) {
        return this.getBalanceObservable(apiKey, AssetModels_1.BALANCE_TYPE_V2.TRADE);
    }
    getManualAccountBalanceObservable(apiKey) {
        return this.getBalanceObservable(apiKey, AssetModels_1.BALANCE_TYPE_V2.TRADER_ACCOUNT);
    }
    getTotalBalanceOverview(apiKey) {
        return this.startIfNeed(apiKey).pipe((0, operators_1.map)((result) => {
            return result.total;
        }));
    }
    getDebtBalanceObservable(apiKey) {
        return this.getBalanceObservable(apiKey, AssetModels_1.BALANCE_TYPE_V2.DEBT);
    }
    getTotalAssetExcludeBot(apiKey) {
        return this.startIfNeed(apiKey).pipe((0, operators_1.map)((balanceInfo) => {
            return balanceInfo.assetExcludeBot || [];
        }));
    }
    getBalanceWithApiUseRestApi(apiKey, repeat = true) {
        return this.getBalanceAcquireObservableV2$(apiKey, repeat);
    }
    getBalanceWithApiKey(apiKey, repeat = true, balanceType) {
        const identify = this.getCacheKey(apiKey, balanceType);
        const dateKey = `${BALANCE_CACHE_TAG}_${identify}_V2_dual`;
        const queryFromCache = BalanceProvider.cachedBalanceMap.has(identify)
            ? () => (0, rxjs_1.of)(BalanceProvider.cachedBalanceMap.get(identify))
            : undefined;
        const requestData = {
            keyId: identify,
            dataKey: dateKey,
            expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
            memoryCache: queryFromCache,
            refresh: () => this.wrapAcquireBalance(apiKey, repeat, balanceType),
        };
        return (0, trade_utils_lib_1.getDataWithCache)(requestData);
    }
    /** @deprecated */
    retrieveFlattenTradeBalance(keyInfo) {
        return this.getBalanceWithApiKey(keyInfo, false)
            .pipe((0, operators_1.map)((balance) => {
            let swapBalance = balance.swap || [];
            let cmSwapBalance = balance.cmSwap || [];
            let arbitrageStrategy = balance.arbitrageStrategy || [];
            let tradeBalance = balance.trade || [];
            let debtBalance = balance.debt || [];
            const balanceInfo = (0, Transform_1.transformTradeBalance)(tradeBalance, debtBalance);
            const balanceList = [...cmSwapBalance, ...arbitrageStrategy, ...swapBalance, ...balanceInfo.trade, ...balanceInfo.debt];
            const total = BalanceHelper_1.BalanceHelper.getBalanceCurrencyOb(balanceList);
            const balanceTotalInfo = balance.total;
            return {
                apiKey: keyInfo,
                balance: balanceTotalInfo,
                tradeBalance: total.trade,
                swapBalance: balance.swap ? total.swap : undefined,
            };
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)({
                apiKey: keyInfo,
                balance: undefined,
                tradeBalance: undefined,
            });
        }));
    }
    /**
     * @deprecated
     * 获取当前所有key的资产
     */
    getAllKeyBalanceStream(apiKeyInfoList) {
        const marketBalanceObservables = apiKeyInfoList.map((value) => {
            return this.retrieveFlattenTradeBalance(value);
        });
        return (0, rxjs_1.merge)(...marketBalanceObservables);
    }
    futureTransferObservable(apiKey, transferParams) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.map)((token) => {
            let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHost}/transfer/`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam);
            let headers = { Authorization: `Bearer ${token.awsToken || ""}` };
            let body = {
                amount: transferParams.amount,
                client_transfer_id: (0, trade_utils_lib_1.random32String)(),
                coin: transferParams.coin,
                direction: transferParams.direction,
            };
            return { url: urlWithCommonParam, headers, body };
        }))
            .pipe((0, operators_1.flatMap)((getReqInfo) => {
            const { url, headers, body } = getReqInfo;
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(url, headers, body, (response) => response);
        }))
            .pipe((0, operators_1.map)((result) => {
            return result.code;
        }));
    }
    getBalanceObservableWithType(apiKey, balanceType) {
        return this.getBalanceObservable(apiKey, balanceType);
    }
}
exports.BalanceProvider = BalanceProvider;
BalanceProvider.instance = new BalanceProvider();
BalanceProvider.cachedBalanceMap = new Map();
function isSameKey(apiKey, apiKey1) {
    return (apiKey !== null &&
        apiKey1 !== null &&
        apiKey !== undefined &&
        apiKey1 !== undefined &&
        apiKey.key === apiKey1.key &&
        apiKey.secret === apiKey1.secret &&
        apiKey.cloudKeyId === apiKey1.cloudKeyId);
}
exports.isSameKey = isSameKey;
/**
 * 库的初始化
 * @param retrieveAPIFunc
 */
function initLib(retrieveAPIFunc) {
    BalanceProvider.setRetrieveApiInterface(retrieveAPIFunc);
}
exports.initLib = initLib;
function apiKey2ExchangeApiKey(apiKey) {
    return {
        key: "",
        secret: "",
        extra: apiKey.alias,
        market: apiKey.exchange,
        cloudKeyId: apiKey.key_id,
    };
}
exports.apiKey2ExchangeApiKey = apiKey2ExchangeApiKey;
